module.exports = __webpack_public_path__ + "media/app/components/Footer/Zalo.0815083b.svg";